<div class="form-group">
  <label>{{label}}   <span class="star" *ngIf="required">*</span></label>
  <div>
    <quill-editor [required]="required" #editor="ngModel" [modules]="modules"
                  [ngModel]="ngModel" (ngModelChange)="ngModelChange.next($event)" [strict]="true" id="content"
                  (onEditorCreated)="onEditorCreated($event)"
    ></quill-editor>
  </div>
  <div class="messages text-danger"
       *ngIf="editor.invalid && editor.dirty && editor.errors?.required">
    {{'errors.required'|translate}}
  </div>
  <app-modal-basic #inputModal>
    <div class="app-modal-header">
      <h4 class="modal-title">{{'admin.dealer_dashboard.input' | translate}}</h4>
      <button type="button" class="close basic-close" (click)="cancelInput()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="app-modal-body">
      <form #inputForm="ngForm">
        <!-- Enter link address -->
        <div class="form-group" *ngIf="'link'===(modalHandler | async)">
          <label for="link_address">{{"admin.dealer_dashboard.enter_link_address" | translate}}<span
            class="star">*</span></label>
          <input name="link_address"
                 id="link_address"
                 class="form-control"
                 placeholder="https://urbansofa.nl"
                 required
                 [(ngModel)]="input_address">
          <span class="form-bar"></span>
        </div>
        <!-- END enter link address -->
        <!-- Upload  -->
        <div class="form-group"
             *ngIf="'image'===(modalHandler | async) || 'video'===(modalHandler | async)|| 'file'===(modalHandler | async)">
          <label for="uploaderFile">{{'global.upload'| translate }}</label>
          <label class="custom-file">
            <input type="file" *ngIf="'video'===(modalHandler | async)" #uploadEl ng2FileSelect [uploader]="uploader"
                   class="custom-file-input form-control"
                   id="uploaderVideo" (change)="fileChange()" accept="video/*">

            <input type="file" *ngIf="'image'===(modalHandler | async)" #uploadEl ng2FileSelect [uploader]="uploader"
                   class="custom-file-input form-control"
                   id="uploaderImage" (change)="fileChange()" accept=".png, .jpeg, .gif, .jpg, .svg, .webp">

            <input type="file" *ngIf="'file'===(modalHandler | async)" #uploadEl ng2FileSelect [uploader]="uploader"
                   class="custom-file-input form-control"
                   id="uploaderFile" (change)="fileChange()" accept="application/*">
            <span class="custom-file-control-upload btn-sm "
                  *ngIf="uploader.queue.length==0">{{"global.choose_file"|translate}}</span>
            <span class="custom-file-control-upload btn-sm "
                  *ngIf="uploader.queue.length>0">{{"global.change_file"|translate}}</span>
            <span
              class="custom-file-control">{{(uploader.queue.length > 0) ? uploader.queue[uploader.queue.length - 1].file.name : ''}}</span>
          </label>
          <div class="row mt-3">
            <!--
            Change Button -->
            <div *ngIf="fileUrl" class="col-sm-8">
              <button (click)="uploadImage()"
                      class="btn btn-primary btn-sm waves-effect waves-light text-nowrap me-2">{{'global.upload'|translate}}</button>
            </div>
          </div>
          <div class="row" *ngIf="isUploading">
            <div class="col-sm-12">
              <!-- Loading Style -->
              <div class="preloader3 loader-block mx-auto">
                <div class="circ1 loader-success"></div>
                <div class="circ2 loader-success"></div>
                <div class="circ3 loader-success"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- END Upload -->
        <!-- Enter image address -->
        <div class="form-group" *ngIf="'image'===(modalHandler | async)">
          <label for="link_address">{{"admin.dealer_dashboard.enter_image_address" | translate}}<span
            class="star">*</span></label>
          <input name="image_address"
                 id="image_address"
                 class="form-control"
                 placeholder="https://urbansofa.nl/logo.png"
                 required
                 [(ngModel)]="input_address"
                 pattern="^https?.+(\.png|\.jpeg|\.gif|\.jpg|\.svg|\.webp)$">
          <span class="form-bar"></span>
        </div>
        <!-- END Enter image address -->
        <!-- Enter video address -->
        <div class="form-group" *ngIf="'video'===(modalHandler | async)">
          <label for="link_address">{{"admin.dealer_dashboard.enter_video_address" | translate}}<span
            class="star">*</span></label>
          <input name="video_address"
                 id="video_address"
                 class="form-control"
                 placeholder="https://urbansofa.nl/advertise.mp4"
                 required
                 [(ngModel)]="input_address">
          <span class="form-bar"></span>
        </div>
        <!-- END Enter video address -->
        <!-- Enter file address -->
        <div class="form-group" *ngIf="'file'===(modalHandler | async)">
          <label for="link_address">{{"admin.dealer_dashboard.enter_file_address" | translate}}<span
            class="star">*</span></label>
          <input name="file_address"
                 id="file_address"
                 class="form-control"
                 placeholder="https://urbansofa.nl/invoice.pdf"
                 required
                 [(ngModel)]="input_address">
          <span class="form-bar"></span>
        </div>
        <!-- END Enter file address -->
      </form>
    </div>
    <div class="app-modal-footer">
      <button type="button" class="btn btn-simple ripple me-4"
              (click)="cancelInput()">{{'global.cancel'|translate}}</button>
      <button type="button" class="btn btn-primary ripple light"
              (click)="acceptInput()" [disabled]="inputForm.invalid">{{'global.ok'|translate}}</button>
    </div>
  </app-modal-basic>
</div>
